
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/panels/messagePanels/publishingBlocked/publishingBlockedForUser.scss.css.virtualfile';
        module.exports = {"root":"_root_1uq9z_1"};